import React from "react";
import { SHOP_PRODUCTS_PATH } from "../../../../helpers/url";
import useActivatedPodHistory from "../../../../hooks/use-activated-pod-history";
import useTranslate from "../../../../hooks/use-translate";
import EmptyMessage from "../../components/EmptyMessage";
import UserAccountLayout from "../../components/UserAccountLayout";
import MyPodProductCard from "./MyPodProductCard";
import { List as ProductsListWrapper } from "../../../../containers/shop/ProductsList";
import { Container } from "@material-ui/core";

const CustomContainer = ({ children }) => (
  <Container maxWidth="xl">{children}</Container>
);

export default function MyPods() {
  const t = useTranslate();
  const { data: podHistory, isLoading } = useActivatedPodHistory();
  const hasPods = podHistory?.content?.length > 0;

  return (
    <UserAccountLayout
      title={t("user.pods.title")}
      showLoading={isLoading && !podHistory}
      customContainer={hasPods ? CustomContainer : undefined}
    >
      {/* No unlocked pods */}
      {!hasPods && (
        <EmptyMessage
          button={{ label: "Browse all products", to: SHOP_PRODUCTS_PATH }}
        >
          {t(`user.pods.noPods`)}
        </EmptyMessage>
      )}

      {/* Unlocked pods history */}
      {hasPods && (
        <ProductsListWrapper>
          {podHistory?.content.map(podHistory => (
            <MyPodProductCard
              key={podHistory.batchId}
              podHistory={podHistory}
            />
          ))}
        </ProductsListWrapper>
      )}
    </UserAccountLayout>
  );
}
